import ProjectStatus from '../../pages/project-management-pmr/shared/enums/project-status'
import ProjectTaskStatus from '../../pages/project-management-pmr/shared/enums/project-task-status'
import { E2EProjectLineMilestoneGroupItemModel } from '../../pages/project-management-pmr/shared/interfaces/pmr-e2e-project-milestone-group-item-model'
import PmrE2EProjectOrderlineModel from '../../pages/project-management-pmr/shared/interfaces/pmr-e2e-project-orderline-model'
import { E2EProjectLineFlexTaskGroupItemModel } from '../../pages/project-management-pmr/shared/interfaces/pmr-e2e-project-task-group-item-model'
import PmrE2EProjectTaskModel from '../../pages/project-management-pmr/shared/interfaces/pmr-e2e-project-task-model'

export default function getLinesAndChildren(
  task: PmrE2EProjectTaskModel | PmrE2EProjectOrderlineModel
) {
  let taskChildren =
    'e2EProjectLineFlexTaskGroupItems' in task ? task.e2EProjectLineFlexTaskGroupItems : []
  let milestoneChildren =
    'e2EProjectLineMilestoneGroupItems' in task ? task.e2EProjectLineMilestoneGroupItems : []

  if ('taskChildren' in task && task.taskChildren.length > 0) {
    taskChildren = taskChildren.concat(task.taskChildren)
  }

  if ('milestoneChildren' in task && task.milestoneChildren.length > 0) {
    milestoneChildren = milestoneChildren.concat(task.milestoneChildren)
  }

  return {
    taskChildren,
    milestoneChildren,
  }
}

export const filterNotCompletedCancelled = {
  task: (item: E2EProjectLineFlexTaskGroupItemModel) =>
    ![ProjectTaskStatus.Completed, ProjectTaskStatus.Cancelled].includes(item.flexTaskStatus),
  milestone: (item: E2EProjectLineMilestoneGroupItemModel) =>
    ![ProjectStatus.Completed, ProjectStatus.Cancelled].includes(item.status),
}
